import { onMounted, onUnmounted, type Ref } from 'vue'
import { animate } from 'animejs'

export interface CounterAnimationOptions {
  duration?: number // 动画持续时间（毫秒）
  threshold?: number // 元素可见多少比例时触发（0-1）
  rootMargin?: string // 提前触发的边距
  ease?: string // animejs 缓动函数
}

/**
 * 数字滚动动画 Composable（使用 animejs）
 * 每次元素进入视口都会触发丝滑的数字滚动动画
 */
export function useCounterAnimation(
  elementRef: Ref<HTMLElement | null>,
  targetNumber: number,
  options: CounterAnimationOptions = {}
) {
  const {
    duration = 1500,
    threshold = 0.1,
    rootMargin = '0px',
    ease = 'out(3)', // easeOutCubic
  } = options

  let observer: IntersectionObserver | null = null

  onMounted(() => {
    if (!elementRef.value) return

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 元素进入视口，使用 animejs 触发丝滑的数字滚动
            const obj = { count: 0 }
            animate(obj, {
              count: targetNumber,
              duration,
              ease,
              onUpdate: () => {
                if (elementRef.value) {
                  elementRef.value.textContent = Math.floor(obj.count) + '+'
                }
              },
            })
          }
          else {
            // 元素离开视口，重置数字
            if (elementRef.value) {
              elementRef.value.textContent = '0+'
            }
          }
        })
      },
      {
        threshold,
        rootMargin,
      }
    )

    observer.observe(elementRef.value)
  })

  onUnmounted(() => {
    if (observer) {
      observer.disconnect()
    }
  })
}
